import * as React from "react";
const SvgCheck = props => <svg width={20} height={20} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><path d="M16.5 5L7.5 14L3.5 10" strokeWidth={1.25} strokeLinecap="round" strokeLinejoin="round" /></svg>;
export default SvgCheck;